export enum BookingFormActionType {
    AddFirstService = 0,
    AddAnotherService = 1,
    EditService = 2,
    AddWaitListBooking = 3,
    AddFirstServiceToWaitListBooking = 4
  }